import { FieldValues, FormState, Path, UseFormRegister } from "react-hook-form";

import { CheckboxButtonList, CheckboxButtonListProps } from "@fronterahealth/frontera-ui-components";

import { getErrorFromFormKey } from "@components/forms/utils";

interface Props<T extends FieldValues> extends Omit<CheckboxButtonListProps, "name" | "legend" | "subtitle" | "ref"> {
  register: UseFormRegister<T>;
  formState: FormState<T>;
  formKey: Path<T>;
  required?: boolean;
}

export const FormCheckboxButtonList = <T extends FieldValues>({
  formState,
  formKey,
  register,

  required = true,
  title,
  ...props
}: Props<T>) => {
  const errorMessage = getErrorFromFormKey(formKey, formState.errors);

  const registerOutput = register(formKey, {
    required: {
      value: required,
      message: `${title} is required`,
    },
  });

  const commonProps = {
    ...props,
    ...registerOutput,
    title,
    legend: `${title} choice`,
    errorMessage,
  };

  return <CheckboxButtonList {...commonProps} />;
};
